// Core
import React, { ReactNode } from 'react'

// Library
import clsx from 'clsx'

// Components
import { ReactComponent as IconQuote } from 'assets/icons/icon_quot_white.svg'

// Styles
import classes from 'components/Onboarding/BlockQuote/BlockQuote.module.scss'

// Interface
interface IBlockQuoteProps {
  srcImage?: ReactNode
  quote: string
  author: string
}

export default function BlockQuote({
  srcImage = null,
  quote,
  author,
}: IBlockQuoteProps) {
  return (
    <div className={clsx(classes.container)}>
      <div className="d-flex justify-content-between">
        <IconQuote />
        {srcImage}
      </div>
      <blockquote>
        {quote}
      </blockquote>
      <figcaption>
        {author}
      </figcaption>
    </div>
  )
}
